import ModelPropertyInterface from "../../../interfaces/model/ModelPropertyInterface";

export default function Properties({properties, mode}: {
    properties: ModelPropertyInterface[],
    mode: "prop" | "desc"
}) {
    return (<>
        {mode === 'prop' && <ul>
            {properties.map(property => <li key={property.id}><p><span>{property.property_name}</span><span>{property.value}</span></p></li>)}
        </ul>}
        {mode === 'desc' && <ul>
            {properties.map(property => <li key={property.id}><p>{property.property_name}</p><p>{property.value}</p></li>)}
        </ul>}
    </>)
}